import React from 'react';

import './EmailPreferenciesPopup.scss';

export default function EmailPreferenciesPopup(props) {
  return (
    <section className="emailPreferenciesPopup">
      <div className="emailPreferenciesPopup_content">
        <p>
          Je kunt je e-mail voorkeuren wijzigen onderaan elke e-mail verzonden
          door zwangerenportaal.nl
        </p>

        <button onClick={() => props.showEmailPreferenciesPopup()}>
          Terug
        </button>
      </div>
    </section>
  );
}
